export default "__VITE_ASSET__BSOKKkqW__"